import "../css/style.scss"

// Our modules / classes
import ButtonFilter from "./modules/ButtonFilter"
import MainMenu from "./modules/MainMenu"
import ModalPost from "./modules/ModalPost"
import SwiperAmbassadors from "./modules/SwiperAmbassadors"
import SwiperGallery from "./modules/SwiperGallery"
import SwiperNews from "./modules/SwiperNews"
import SwiperTiles from "./modules/SwiperTiles"
import SwiperVideos from "./modules/SwiperVideos"

// Instantiate a new object using our modules/classes
const buttonFilter = new ButtonFilter()
const mainMenu = new MainMenu()
const modalPost = new ModalPost()
const swiperAmbassadors = new SwiperAmbassadors()
const swiperGallery = new SwiperGallery()
const swiperNews = new SwiperNews()
const swiperTiles = new SwiperTiles()
const swiperVideos = new SwiperVideos()

